import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import "../../styles.css";
import MisAves from "./MisAves/MisAves";
import { useShoppingContext } from "../../context/ShoppingContext";
import DashboardButtons from "../DashboardButtons/DashboardButtons";

const Aves = () => {
  const {
    setTodayDate,
    aves,
    fetchMisAves,
    fetchAlimentos,
    fetchProduccionHuevos,
    isDarkMode,
  } = useShoppingContext();

  const [highlightAddButton, setHighlightAddButton] = useState(false);

  useEffect(() => {
    fetchMisAves();
    fetchProduccionHuevos();
    setTodayDate(getTodayDate());
    fetchAlimentos();
  }, [fetchMisAves, fetchAlimentos, setTodayDate, fetchProduccionHuevos]);

  const getTodayDate = () => {
    const today = new Date();
    return today.toLocaleDateString("es-ES", {
      weekday: "short",
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  };

  const handleOnboardingClick = () => {
    setHighlightAddButton(true);
    setTimeout(() => {
      setHighlightAddButton(false);
    }, 6000); // Mantiene la señalización activa por 6 segundos
  };

  return (
    <div className={isDarkMode ? "content-container" : "content-container light"}>
      <DashboardButtons />

      {highlightAddButton && (
        <div className="highlight-message">
          <FontAwesomeIcon icon={faArrowUp} className="arrow-icon" />
          <span>Haz click arriba para añadir aves</span>
        </div>
      )}
      {aves.length === 0 ? (
        <div className="onboarding-container">
          <h2 className="onboarding-header">Bienvenido a la gestión de aves</h2>
          <p className="onboarding-text">
            Parece que aún no has registrado ninguna ave. Empieza por aprender
            cómo hacerlo.
          </p>
          <button onClick={handleOnboardingClick} className="btn btn-secondary">
            Muéstrame cómo empezar
          </button>
        </div>
      ) : (
        <div className="table-container">
          <MisAves />
        </div>
      )}
    </div>
  );
};

export default Aves;
